// BookTickets/stages/PaymentProcess/lib/paymentUrls.ts

export function buildPaypalReturnUrls(args: { pathname: string; cartId: string; flow?: string }) {
  const origin = typeof window !== 'undefined' ? window.location.origin : ''

  const successQs = new URLSearchParams()
  successQs.set('cartId', args.cartId)
  successQs.set('paymentMethod', 'paypal')
  if (args.flow) successQs.set('flow', args.flow)

  const errorQs = new URLSearchParams()
  errorQs.set('error', 'true')
  if (args.flow) errorQs.set('flow', args.flow)

  return {
    successUrl: `${origin}${args.pathname}?${successQs.toString()}`,
    errorUrl: `${origin}${args.pathname}?${errorQs.toString()}`,
  }
}
